import React from "react"
import PropTypes from "prop-types"
import {
  MenuList,
  Menu,
  MenuItem,
  MenuButton,
  Button,
  Link,
  ChevronRightIcon,
} from "datastory-shared/ui"

import {
  SHARE_SITES_ITEMS,
  buildShareUrl,
  handleCalendarClick,
} from "utils/calendar"

export const AddToCalendar = ({ name, date }) => {
  const calendarTimeFormat = d =>
    new Date(d).toISOString().replace(/-/g, "").split("T")[0]

  const startDatetime = calendarTimeFormat(date) + "T000000+00"
  const endDatetime = calendarTimeFormat(date) + "T235959+00"

  const event = {
    title: name,
    description: "",
    duration: "",
    location: "",
    startDatetime,
    endDatetime,
  }

  return (
    <Menu isLazy>
      <MenuButton as={Button} rightIcon={<ChevronRightIcon />}>
        Add to Calendar
      </MenuButton>
      <MenuList>
        {SHARE_SITES_ITEMS.map(i => {
          const href = buildShareUrl(event, i)
          return (
            <MenuItem
              key={i}
              onClick={e => handleCalendarClick(e, href, "download")}
            >
              <Link href={href}>{i}</Link>
            </MenuItem>
          )
        })}
      </MenuList>
    </Menu>
  )
}

AddToCalendar.propTypes = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
}

export { buildShareUrl, handleCalendarClick }
